import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { nullSafe } from 'src/app/utils';

@Component({
  selector: 'eos-ar-comment',
  templateUrl: './ar-comment.component.html'
})
export class ArCommentComponent implements OnInit {

  @Input() isApprove: boolean;
  @Input() checkBoxLabel: string = null;
  @Input() comment: string = '';
  @Input() header = "Add Comments";
  @Input() message = "Message";


  candidateSent = false;
  constructor(public modal: NgbActiveModal) { }

  ngOnInit() {
  }

  canConfirm() {
    if (this.isApprove || nullSafe<number>(() => this.comment.trim().length, -1) > 0) {
      return true;
    }
    return false;
  }

}
